// extracted by mini-css-extract-plugin
module.exports = {"category__wrapper":"styles_category__wrapper__1oLwa","active":"styles_active__3vJNq"};